module.exports = __webpack_public_path__ + "img/6507.55b90e4a.jpg";